import { cache } from "react";
import type { CountryType, Nullable } from "../../../@types/generic";
import { fetcher } from "../index";
import type { LocationSummary } from "../types/locationSummary";

export const getLocationSummary = cache(
    async (
        code: string,
        country: CountryType,
        limitForecastSummaryItems?: number
    ): Promise<Nullable<LocationSummary>> =>
        fetcher<LocationSummary>(
            {
                path: `/location-summary/${code}/`,
                params: { limitForecastSummaryItems },
            },
            {
                country,
            }
        ).catch(() => null)
);
